module.exports = __webpack_public_path__ + "static/media/logo.7e455ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/images/logo.png
// module id = 318
// module chunks = 0